import { UserRole } from '@garden-platform/shared';
import { Building, Building2, ClipboardList, LayoutDashboard, Shield, Users } from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar';
import { useAuth } from '@/contexts/AuthContext';
import { NavMain } from './nav-main';
import { NavUser } from './nav-user';
import { OrgSwitcher } from './org-switcher';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user, organization } = useAuth();

  const isAdmin = user?.role === UserRole.ADMIN;

  const navMain = [
    {
      title: 'Overview',
      url: '/dashboard',
      icon: LayoutDashboard,
    },
    {
      title: 'Orders',
      url: '/orders',
      icon: ClipboardList,
    },
    {
      title: 'Contacts',
      url: '/contacts',
      icon: Building2,
    },
  ];

  const navAdmin = isAdmin
    ? [
        {
          title: 'Members',
          url: '/dashboard/members',
          icon: Users,
        },
        {
          title: 'Sessions',
          url: '/dashboard/sessions',
          icon: Shield,
        },
        {
          title: 'Organization',
          url: '/dashboard/organization',
          icon: Building,
        },
      ]
    : [];

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <OrgSwitcher organization={organization} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} label="Menu" />
        {navAdmin.length > 0 && <NavMain items={navAdmin} label="Admin" />}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
